export const validateUserForm = (state, checkStatus, isEditMode = false) => {
  const errors = {};

  if (!state.fullName) {
    errors.fullName = "Full name is required";
  }

  if (!state.email) {
    errors.email = "Email is required";
  }

  if (!state.mobile) {
    errors.mobile = "Mobile number is required";
  } else if (!/^\d{10}$/.test(state.mobile.trim())) {
    errors.mobile = "Mobile number must be 10 digits";
  }

  if (!state.country) {
    errors.country = "Country is required";
  }
  if (!isEditMode && !state.password) {
    errors.password = "Password is required";
  } else if (!isEditMode && state.password.length < 6) {
    errors.password = "Password must be at least 6 characters";
  }

  if (!state.profilePic && !isEditMode) {
    errors.profilePic = "Profile Pic is required";
  } else if (
    state.profilePic instanceof File &&
    state.profilePic.size > 2 * 1024 * 1024
  ) {
    errors.profilePic = "Profile Pic must be less than 2 MB";
  }

  if (!checkStatus) {
    errors.status = "Status is required";
  }

  return errors;
};

// Category ------------------------------------------

export const validateCategoryForm = (
  state,
  categoryStatus,
  isEditMode = false
) => {
  const errors = {};

  if (!state.categoryName?.trim()) {
    errors.categoryName = "Category name is required";
  }

  if (!state.categoryIcons && !isEditMode) {
    errors.categoryIcons = "Category icon is required";
  } else if (
    state.categoryIcons instanceof File &&
    state.categoryIcons.size > 2 * 1024 * 1024
  ) {
    errors.categoryIcons = "Category icon must be less than 2 MB";
  }

  if (!state.description?.trim()) {
    errors.description = "Description is required";
  }

  if (!categoryStatus) {
    errors.status = "Status is required";
  }

  return errors;
};

// Change Password ------------------------------------

export const validateChangePassword = (passwordState) => {
  const errors = {};

  if (!passwordState.oldPassword?.trim()) {
    errors.oldPassword = "Old password is required";
  }

  if (!passwordState.newPassword?.trim()) {
    errors.newPassword = "New password is required";
  } else if (passwordState.newPassword.length < 6) {
    errors.newPassword = "Password must be at least 6 characters";
  }

  if (!passwordState.confirmPassword?.trim()) {
    errors.confirmPassword = "Confirm your new password";
  } else if (passwordState.newPassword !== passwordState.confirmPassword) {
    errors.confirmPassword = "Passwords do not match";
  }

  if (
    passwordState.oldPassword &&
    passwordState.newPassword &&
    passwordState.oldPassword === passwordState.newPassword
  ) {
    errors.newPassword = "New password must be different from old password";
  }

  return errors;
};

// Notification ---------------------------------------

export const validateNotificationForm = (state, isEditMode = false) => {
  const errors = {};

  if (!state.notificationTitle) {
    errors.notificationTitle = "Notification title is required";
  }

  if (!state.categoryId?.trim()) {
    errors.categoryId = "Category is required";
  }
  if (!state.backgroundColor?.trim()) {
    errors.backgroundColor = "BackgroundColor is required";
  }
  if (!state.countryName?.trim()) {
    errors.countryName = "Country Name is required";
  }
  if (!state.latitude) {
    errors.latitude = "Latitude is required";
  }
  if (!state.longitude) {
    errors.longitude = "Longitude is required";
  }

  if (!state.startDate) {
    errors.startDate = "Start date is required";
  }

  if (!state.endDate) {
    errors.endDate = "End date is required";
  }

  if (!state.description?.trim()) {
    errors.description = "Description is required";
  }

  if (!state.address?.trim()) {
    errors.address = "Address is required";
  }

  if (!state.scheduleDate && !isEditMode) {
    if (!state.pushNow) {
      errors.scheduleDate = "Logo is required";
    }
  }
  if (state.startDate && state.endDate) {
    const start = new Date(state.startDate);
    const end = new Date(state.endDate);
    if (end < start) {
      errors.endDate = "End date cannot be before start date";
    }
  }



  if (!state?.logo && !isEditMode) {
    errors.logo = "Logo is required";
  } else if (
    state?.logo instanceof File &&
    state?.logo.size > 2 * 1024 * 1024
  ) {
    errors.logo = "Logo must be less than 2 MB";
  }

  if (!state?.bannerImage && !isEditMode) {
    errors.bannerImage = "Banner is required";
  } else if (
    state?.bannerImage instanceof File &&
    state?.bannerImage.size > 2 * 1024 * 1024
  ) {
    errors.bannerImage = "Banner must be less than 2 MB";
  }

  // if (!state?.mediaFiles && !isEditMode) {
  //     errors.mediaFiles = 'Media Files is required';
  // } else if (state?.mediaFiles instanceof File && state?.mediaFiles.size > 2 * 1024 * 1024) {
  //     errors.mediaFiles = 'Media Files must be less than 2 MB';
  // }

  return errors;
};
